export default function doesBrowserSupportPositionSticky() {
  if (typeof document !== 'undefined') {
    // Create a node
    const testNode = document.createElement('div');
    // Try to apply a vendor prefixed sticky property
    ['', '-webkit-', '-moz-', '-o-', '-ms-'].forEach((prefix) => {
      testNode.style.position = prefix + 'sticky';
    });
    // Return true if position property is valid
    return testNode.style.position !== '';
  }
  // Return false if document is not present
  return false;
}
